module.exports = __webpack_public_path__ + "img/5icon@2x.bd7d74f8.png";